import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useLocation, useNavigate } from "react-router-dom";
import { TEXT } from "../../dark-theme/palette";
import UserCustomButton from "../components/UserCustomButton";
import { trackEvent } from "../../services/GoogleAnalytics";

export default function Error() {
    const navigate = useNavigate();
    const location = useLocation();
    const [message, setMessage] = useState();
    const [code, setCode] = useState();

    useEffect(() => {
        trackEvent("entered", { name: "Error" });
    }, []);

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const message = searchParams.get("message");
        const code = searchParams.get("code");
        setMessage(message);
        setCode(code);
        // Logger.log(message);
    }, []);

    const handleContact = () => {
        navigate("/contact");
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={0}>
                <Grid
                    size={{ xs: 12 }}
                    sx={{
                        padding: "160px",
                        color: TEXT.primary,
                        display: "flex",
                        justifyContent: "flex-start",
                        textAlign: "left",
                    }}
                >
                    <Box sx={{ width: "100%" }}>
                        {/* <TopLine>IOT Service Provider</TopLine> */}
                        <Box sx={{ color: TEXT.primary, fontSize: "48px", fontWeight: 600, mb: 6 }}>Oops! Something Went Wrong.</Box>
                        {message && <Box sx={{ color: TEXT.primary, fontSize: "18px", mb: 3 }}>{message}</Box>}
                        {code && code === "ERR_CODE_SUB_AGAIN" && (
                            <Box sx={{ color: TEXT.primary, fontSize: "18px", mb: 3 }}>
                                We're sorry, but it appears there was a token mismatch during verification.<br></br>Please try subscribing again. If you
                                encounter more issues, feel free to contact our support team. Thank you!"
                            </Box>
                        )}
                        <Box sx={{ color: TEXT.primary, fontSize: "18px" }}>
                            <UserCustomButton onClick={handleContact}>Contact Us</UserCustomButton>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
